import { render, staticRenderFns } from "./Server-Partner.vue?vue&type=template&id=7ff02416&scoped=true&"
import script from "./Server-Partner.vue?vue&type=script&lang=js&"
export * from "./Server-Partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff02416",
  null
  
)

export default component.exports